/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IBodegasPersonas from 'Infotrack@Modelos/smartStock/bodegasPersonas/entidades/bodegasPersonas';
import IBodegasPersonasCompuesta from 'Infotrack@Modelos/smartStock/bodegasPersonas/entidades/bodegasPersonasCompuesta';
import React from 'react';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import BodegasPersonasCM from '../controladorModelo/bodegasPersonasCM';
import { acciones, IEstadoGestionBodegas } from '../reductorGestionBodegas';
import BodegasPersonasVista from '../vista/tablaBodegasPersonasVista';

import { useSelector } from 'react-redux';

const bodegasPersonasCM = new BodegasPersonasCM();

const TableBodegasPersonasCV: React.FunctionComponent = () => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual);
    const idAplicacion = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.usuarioAplicacionAgenciaActual!.IdAplicacion);
    const cargaInicial = React.useRef(true);
    const [bodegasPersonass, setBodegasPersonass] = React.useState<IBodegasPersonas[]>([]);
    const [{ bodega, recargarTablaBodegaPersona }, dispatch] = useProveedor<IEstadoGestionBodegas>();

    React.useEffect(() => {
        if (recargarTablaBodegaPersona || cargaInicial.current) {
            cargarBodegasPersonas();
            if (recargarTablaBodegaPersona) {
                dispatch({ type: acciones.RECARGAR_TABLA_BODEGA_PERSONA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarBodegasPersonas = async () => {
        setBodegasPersonass(
            await (
                await bodegasPersonasCM.consultarBodegasPersonasCompuesta({
                    BodegaId: Number(bodega.BodegaId),
                    AgenciaId: idAgencia!.IdAgencia,
                    AplicacionId: idAplicacion,
                })
            ).map((bodegaPersona: IBodegasPersonasCompuesta) => {
                bodegaPersona.Persona = {
                    IdActividadEconomica: 0,
                    IdMunicipio: 0,
                    IdTipoIdentificacion: 0,
                    IdTipoRegimen: 0,
                    PrimerNombre: '',
                    SegundoNombre: '',
                    PrimerApellido: '',
                    SegundoApellido: '',
                    Foto: '',
                    Estado: 1,
                    Direccion: '',
                    Telefonos: '',
                    EmailAlterno: '',
                    EmailPrincipal: '',
                    NumeroIdentificacion: '',
                    IdTipoContribuyente: 0,
                    DigitoVerificacion: '',
                    Celular: '',
                    IdEmpresa: '',
                    IdPersona: bodegaPersona.PersonaId,
                    NombrePersona: bodegaPersona.NombrePersona,
                    IdUsuario: '',
                };
                return bodegaPersona;
            }).filter(x => x.IdAplicacion ===idAplicacion)
        );
    };

    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadBodegasPersonas?: IBodegasPersonas) => {
        dispatch({ type: acciones.ESTABLECER_BODEGA_PERSONA, payload: entidadBodegasPersonas });
        dispatch({ type: acciones.MODIFICAR_TIPO_FORMULARIO_BODEGA_PERSONA, payload: tipoFormulario });
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO_BODEGA_PERSONA });
    };

    const confirmarEliminacion = (bodegasPersonas: IBodegasPersonas) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarBodegasPersonas(bodegasPersonas),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarBodegasPersonas = (bodegasPersonas: IBodegasPersonas) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        
        bodegasPersonasCM.eliminarBodegasPersonas(bodegasPersonas).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA_BODEGA_PERSONA });
        });
    };

    return (
        <BodegasPersonasVista
            bodegasPersonass={bodegasPersonass}
            cargarBodegasPersonas={cargarBodegasPersonas}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableBodegasPersonasCV;
